import { AlertBodyText, AlertCard, COLORS, CloseIconButton } from "@/theme"
import i18n from "@/translations/i18n"
import React from "react"

/**
 * This should be displayed when users are updating a configuration value,
 * including sensors, device names, installation types etc.
 */
export function UpdateConfigurationWarning() {
  const [isOpen, setIsOpen] = React.useState(true)

  if (isOpen) {
    return (
      <AlertCard
        maxW={"$full"}
        severity={"warning"}
        titleText={i18n.t("warning")}
        w={"$full"}
        actionElement={
          <CloseIconButton
            iconColor={COLORS.$textDark.primary}
            size={"sm"}
            variant={"text"}
            onPress={() => setIsOpen(false)}
          />
        }
      >
        <AlertBodyText fontSize={"$sm"}>
          {i18n.t(
            "deviceConfiguration:updateConfigurationSwitchOnToOffWarning",
          )}
        </AlertBodyText>
        <AlertBodyText fontSize={"$sm"}>
          {i18n.t("deviceConfiguration:updateConfigurationDataLossWarning")}
        </AlertBodyText>
      </AlertCard>
    )
  }
  return null
}
